import { render, staticRenderFns } from "./Component-NewTask-Home.vue?vue&type=template&id=1e299d92&"
import script from "./Component-NewTask-Home.vue?vue&type=script&lang=js&"
export * from "./Component-NewTask-Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports